<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="formObserver">
    <b-form v-if="dossierSelected" @submit.prevent="handleSubmit(send())">
      <div class="block-flat">
        <div class="header">
          <h3>Informations complémentaires</h3>
        </div>

        <div class="block-content">
          <fieldset>
            <div class="form-group">
              <b-alert show variant="info" class="no-margin-bottom mt-3 ">
                La fin d’application pour une permission de voirie en RIP est la
                date de fin de la DSP
              </b-alert>
              <b-row>
                <b-col
                  xl="3"
                  lg="6"
                  md="6"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label"
                    >Date prévue de début d'application
                    <span class="red">*</span> :</label
                  >
                </b-col>
                <b-col xl="9" lg="6" md="6" sm="12" cols="12">
                  <ValidationProvider
                    mode="lazy"
                    v-slot="{ errors }"
                    rules="required"
                    name="date de début"
                  >
                    <b-form-datepicker
                      hide-header
                      :start-weekday="1"
                      v-model="request.dateStart"
                      placeholder="Date prévue de début d'application"
                      @input="calcNumberDays($event)"
                      today-button
                      :state="errors[0] ? false : null"
                      today-button-variant="primary"
                      label-help=""
                      label-today-button="Aujourd'hui"
                    ></b-form-datepicker>
                    <div class="error">{{ errors[0] }}</div>
                  </ValidationProvider>
                </b-col>
                <b-col
                  xl="3"
                  lg="6"
                  md="6"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label"
                    >Date prévue de fin d'application
                    <span class="red">*</span> :
                  </label>
                </b-col>
                <b-col xl="9" lg="6" md="6" sm="12" cols="12">
                  <ValidationProvider
                    mode="lazy"
                    v-slot="{ errors }"
                    rules="required"
                    name="date de fin"
                  >
                    <b-form-datepicker
                      hide-header
                      :state="errors[0] ? false : null"
                      :start-weekday="1"
                      v-model="request.dateEnd"
                      @input="calcNumberDays($event)"
                      placeholder="Date prévue de fin d'application"
                      today-button
                      today-button-variant="primary"
                      label-help=""
                      label-today-button="Aujourd'hui"
                    ></b-form-datepicker>
                    <div class="error">{{ errors[0] }}</div>
                  </ValidationProvider>
                  <!--  -->
                </b-col>
                <b-col
                  xl="3"
                  lg="6"
                  md="6"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">Nombre de jours : </label>
                </b-col>
                <b-col xl="9" lg="6" md="6" sm="12" cols="12">
                  <b-form-input
                    :disabled="true"
                    type="number"
                    v-model="request.numberDays"
                  />
                </b-col>
              </b-row>
              <b-row
                v-if="
                  userConnected &&
                    (userConnected.roles.includes('ROLE_SOUSTRAITANT') ||
                      userConnected.roles.includes('ROLE_ADMIN')) &&
                    request.showComboOperator
                "
              >
                <b-col lg="4" md="4" sm="12" cols="12">
                  <label class="control-label"><b>Opérateur :</b></label>
                  <!-- <span class="red">*</span> -->
                </b-col>
                <b-col lg="8" md="8" sm="12" cols="12">
                  <!-- <ValidationProvider
                    mode="lazy"
                    v-slot="{ errors }"
                    rules="required"
                    name="Opérateur"
                  > -->
                  <!--  :class="errors[0] ? 'error' : ''" -->
                  <!-- <autocomplete
                    v-validate="'required'"
                    @selected="selectedOperator"
                    results-property="data"
                    :request-headers="{ Authorization: token }"
                    :source="urlapi + request.queryOperator"
                    resultsValue="id"
                    resultsDisplay="libelle"
                    placeholder="Recherche..."
                    :initial-value="
                      request.operator != null ? request.operator.id : null
                    "
                    :initialDisplay="
                      request.operator != null ? request.operator.libelle : null
                    "
                    input-class="form-control"
                  >
                    <template v-slot:noResults>
                      Pas de résultat
                    </template>
                  </autocomplete> -->
                  <autocomplete-sudthd
                    :rules="'required'"
                    :validationName="'Opérateur'"
                    @selected="selectedOperator"
                    results-property="data"
                    :request-headers="{ Authorization: token }"
                    :source="urlapi + request.queryOperator"
                    resultsValue="id"
                    resultsDisplay="libelle"
                    :searchOnLoad="true"
                    placeholder="Recherche..."
                    :initial-value="
                      request.operator != null && request.operator != {}
                        ? request.operator.id
                        : null
                    "
                    :initialDisplay="
                      request.operator != null && request.operator != {}
                        ? request.operator.libelle
                        : null
                    "
                    input-class="form-control"
                  >
                    <template v-slot:noResults>
                      Pas de résultat
                    </template>
                  </autocomplete-sudthd>
                  <!-- <div class="error">{{ errors[0] }}</div>
                  </ValidationProvider> -->
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  xl="2"
                  lg="3"
                  md="3"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label"><b>Numéro d'affaire :</b></label>
                </b-col>
                <b-col xl="10" lg="9" md="9" sm="12" cols="12">
                  <b-input
                    v-model="request.caseNumbers"
                    placeholder="Numéro d'affaire"
                  ></b-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col
                  xl="2"
                  lg="3"
                  md="3"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label"><b>Code opération :</b></label>
                </b-col>
                <b-col xl="10" lg="9" md="9" sm="12" cols="12">
                  <b-input
                    v-model="request.operationCode"
                    placeholder="Code opération"
                  ></b-input>
                </b-col>
              </b-row>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="stepper-control">
        <b-button
          variant="white"
          @click="previous"
          class="btn marginRight-10 marginBottom-15"
        >
          <font-awesome-icon
            icon="caret-left"
            class="marginRight-5"
          ></font-awesome-icon>
          Précédent
        </b-button>
        <b-button type="submit" variant="primary" class="marginBottom-15">
          <span>Suivant</span>
          <font-awesome-icon
            icon="caret-right"
            class="marginLeft-5"
          ></font-awesome-icon>
        </b-button>
      </div>
    </b-form>
  </ValidationObserver>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import autocompleteSudThd from "../../components/Autocomplete.vue";
export default {
  props: ["add"],
  components: {
    "autocomplete-sudthd": autocompleteSudThd,
  },
  async mounted() {
    console.log(this.request);
    if (this.add == false) {
      this.request.dateStart = this.formatDate(this.request.dateStart);
      this.request.dateEnd = this.formatDate(this.request.dateEnd);
    }
  },
  methods: {
    formatDate(date) {
      if (date) {
        let date_split = date.split("/");
        return date_split[2] + "-" + date_split[1] + "-" + date_split[0];
      } else {
        return null;
      }
    },
    previous() {
      this.$emit("previous");
    },
    calcNumberDays(value) {
      if (this.request.dateStart != null && this.request.dateEnd != null) {
        let date1 = new Date(this.request.dateStart);
        let date2 = new Date(this.request.dateEnd);
        let Difference_In_Days =
          (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24);
        this.request.numberDays = Difference_In_Days + 1;
      }
    },
    ...Vuex.mapActions("Perimeter", ["getPerimeters"]),
    ...Vuex.mapActions("Dossiers", ["setDossier"]),
    selectedOperator(data) {
      this.request.operatorPerimeterId = data.selectedObject.id;
      this.request.operator = data.selectedObject;
      // this.$refs.autocomplete.clear()
    },

    send() {
      this.$refs.formObserver.validate().then((success) => {
        if (success == true) {
          this.$emit("submit");
        } else {
          this.$emit("error", "Veuillez corriger les erreurs du formulaire");
        }
      });
    },
  },
  data: () => ({ operators: [], urlapi: window.urlapi }),
  computed: {
    request: {
      get: function() {
        return this.dossierSelected;
      },
      set: function(newValue) {
        this.setDossier(newValue);
      },
    },
    ...Vuex.mapGetters("Dossiers", ["dossierSelected"]),
    ...Vuex.mapGetters("Authentification", ["userConnected", "token"]),
  },
};
</script>

<style></style>
